export default __webpack_public_path__ + "static/media/fashion.4c6a7a39.png";